const Notificacion = ({notificacion}) => {
  return (<div></div>);
}

export default Notificacion